window.addEventListener('load', () => {
    const mailtoLinkPresent = document.querySelector('a[href^="mailto:"]');

    if (!!mailtoLinkPresent) {
        let lock = false;

        document.addEventListener('click', async (event) => {
            const target = event.target;
            if (target.matches('a[href^="mailto:"]') || target.parentElement?.matches('a[href^="mailto:"]')) {
                if (lock) return;
                lock = true;
                const link = target.closest('a[href^="mailto:"]');

                link.classList.add('relative');
                link.classList.remove('overflow-hidden');

                const email = link.getAttribute('href').replace('mailto:', '');

                try {
                    await navigator.clipboard.writeText(email);

                    // Create and show feedback div
                    const notice = document.createElement('div');
                    notice.className = 'copied-notice';
                    notice.textContent = 'Copied Email!';
                    link.appendChild(notice);

                    // Remove it after 2 seconds
                    setTimeout(() => {
                        notice.remove();
                        lock = false;
                        link.classList.remove('relative');
                    }, 2000);
                } catch (error) {
                    console.error('Failed to copy email:', error);
                    lock = false;
                }
            }
        });
    }
});
